import { http } from '@/providers/apis/http';
import { groupsSerializer } from '@/providers/serializers/groups/groups';

export class GroupsAPI {
  public static INSTANCE = new GroupsAPI();

  private namespace: string = 'api/reports/v1/groups';
  private namespaceAdmin: string = 'api/admin/v1/group';

  public fetchUserHierarchies() {
    const endpoint = `${this.namespace}/hierarchies/user`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers).then((response) => {
      return groupsSerializer.serializeUserHierarchies(response.data);
    });
  }

  public fetchHierarchyMapping(params: any) {
    const endpoint = `${this.namespaceAdmin}/hierarchy/mapping`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, params).then((response) => {
      return groupsSerializer.serializeMappingData(response.data);
    }).catch((error: any) => {
      return [];
    });
  }

  public fetchGroupedHierarchyMapping(params: any) {
    const endpoint = `${this.namespaceAdmin}/hierarchy/mapping/all`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, params).then((response) => {
      return groupsSerializer.serializeGroupedHierarchyMapping(response.data);
    }).catch((error: any) => {
      return [];
    });
  }
}

export const groupsApi = GroupsAPI.INSTANCE;
